/**
 * Local multiplayer room code: 5 digits, designed for a child
 * to type it on a large numeric keypad. The signaling server
 * generates it; the normalization/validation shared by the UI lives here.
 */

export const ROOM_CODE_LENGTH = 5;

/** Leaves only digits (tolerates spaces, hyphens and keyboard leftovers). */
export function normalizeRoomCode(raw: string): string {
  return raw.replaceAll(/\D/g, "");
}

export function isCompleteRoomCode(raw: string): boolean {
  return normalizeRoomCode(raw).length === ROOM_CODE_LENGTH;
}
